import { Deferred, Effect, Layer, Scope } from "effect";
import { editorElementFocusFailure } from "./element-focus-model.ts";
import { EditorElementFocusIo } from "./element-focus-service.ts";
export const EditorElementFocusIoLive = Layer.succeed(EditorElementFocusIo, {
  frame: Effect.scoped(Effect.gen(function* () {
    const tick = yield* Deferred.make<void>(), resume = () => { Deferred.doneUnsafe(tick, Effect.void); };
    yield* Effect.acquireRelease(
      Effect.try({ try: () => typeof requestAnimationFrame === "function"
        ? { _tag: "Frame" as const, id: requestAnimationFrame(resume) }
        : { _tag: "Timeout" as const, id: setTimeout(resume, 0) }, catch: editorElementFocusFailure }),
      handle => Effect.try({ try: () => { if (handle._tag === "Frame") cancelAnimationFrame(handle.id); else clearTimeout(handle.id); }, catch: editorElementFocusFailure }).pipe(Effect.orDie)
    );
    yield* Deferred.await(tick);
  })).pipe(Effect.provideService(Scope.PreserveFinalizerFailures, true)),
  focus: (target, id) => Effect.try({ try: () => {
    if (!target.isConnected) return;
    const element = [...target.querySelectorAll<HTMLElement>("[id]")].find(node => node.id === id);
    if (!element || element.closest("[data-editor-layout-group]")?.getAttribute("data-focused") !== "true") return;
    if (element.getAttribute("role") === "tab" && element.getAttribute("aria-selected") !== "true") return;
    element.focus();
  }, catch: editorElementFocusFailure })
});
